import { render, staticRenderFns } from "./RecruiterAdd.vue?vue&type=template&id=7832c2f6&"
import script from "./RecruiterAdd.vue?vue&type=script&lang=js&"
export * from "./RecruiterAdd.vue?vue&type=script&lang=js&"
import style0 from "./RecruiterAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports